import type { ConsolePageOption, ConsolePageService, Plugin } from '@/plugins'
import { CORE_PLUGIN } from '@/core'
import {
  container,
  injectable,
  instanceCachingFactory,
  registry,
  singleton,
} from 'tsyringe'
import type { App } from 'vue'
import OrderManagement from './view/OrderManagement.vue'
import OrderDetail from './view/components/OrderDetail.vue'
import orderComment from './view/components/Comment.vue'
import { PLUGIN_CONSOLE_PAGE } from '@/plugins/builtin/BuiltinPluginSymbol'
/**
 * 插件的Option定义
 */
@singleton()
@registry([
  {
    token: CORE_PLUGIN,
    useFactory: instanceCachingFactory<Plugin<unknown, unknown>>((c) =>
      c.resolve(OrderManagementPagePlugin)
    ),
  },
])
@injectable()
export class OrderManagementPagePlugin implements Plugin<unknown, unknown> {
  id: string | symbol = ''
  options: unknown
  service: unknown

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  init(app: App<Element>): void {
    const plugin =
      container.resolve<Plugin<ConsolePageOption, ConsolePageService>>(
        PLUGIN_CONSOLE_PAGE
      )
    plugin.service.addChildRoute({
      path: 'orders/order_management',
      name: 'orderManagement',
      component: OrderManagement,
    })
    plugin.service.addChildRoute({
      path: 'orders/order_management/:id',
      name: 'orderDetail',
      component: OrderDetail,
    })
    plugin.service.addChildRoute({
      path: 'orders/order_management/comment/:id',
      name: 'orderComment',
      component: orderComment,
    })
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  initialized(app: App<Element>): void {

  }
}
